import type { DiasporaOriginConfig } from "@/pages/connect-portal/countries/DiasporaConnectPage";

export const DIASPORA_ORIGINS: Record<string, DiasporaOriginConfig> = {
  "call-from-us": {
    name: "the United States", slug: "call-from-us", iso2: "US", flag: "🇺🇸",
    emergencyNumber: "911", currency: "USD",
    regulatoryNotice: "elefa Connect is an over-the-top VoIP service and cannot be used to call 911. In accordance with FCC regulations, always maintain access to a traditional phone for emergencies.",
    popularDestinations: [
      { name: "Nigeria", flag: "🇳🇬", slug: "nigeria", dialCode: "234" },
      { name: "Ethiopia", flag: "🇪🇹", slug: "ethiopia", dialCode: "251" },
      { name: "Kenya", flag: "🇰🇪", slug: "kenya", dialCode: "254" },
      { name: "South Sudan", flag: "🇸🇸", slug: "south-sudan", dialCode: "211" },
    ],
    seoTitle: "Affordable International Calls from the USA | elefa Connect",
    seoDescription: "Make affordable HD international calls from the United States to Nigeria, Ethiopia, Kenya, South Sudan and every country worldwide. No contracts, credit never expires.",
  },
  "call-from-uk": {
    name: "the United Kingdom", slug: "call-from-uk", iso2: "GB", flag: "🇬🇧",
    emergencyNumber: "999", currency: "GBP",
    regulatoryNotice: "elefa Connect is an internet-based calling service and cannot be used to call 999 or 112 emergency services. In line with Ofcom requirements, always have a traditional phone available for emergencies.",
    popularDestinations: [
      { name: "Nigeria", flag: "🇳🇬", slug: "nigeria", dialCode: "234" },
      { name: "Somalia", flag: "🇸🇴", slug: "somalia", dialCode: "252" },
      { name: "Kenya", flag: "🇰🇪", slug: "kenya", dialCode: "254" },
      { name: "Ethiopia", flag: "🇪🇹", slug: "ethiopia", dialCode: "251" },
    ],
    seoTitle: "Affordable International Calls from the UK | elefa Connect",
    seoDescription: "Make affordable HD international calls from the UK to Nigeria, Somalia, Kenya, Ethiopia and every country worldwide. No contracts, credit never expires.",
  },
  "call-from-canada": {
    name: "Canada", slug: "call-from-canada", iso2: "CA", flag: "🇨🇦",
    emergencyNumber: "911", currency: "CAD",
    regulatoryNotice: "elefa Connect is a VoIP service and cannot be used to call 911. Per CRTC regulations, always have access to a traditional phone for emergency calls.",
    popularDestinations: [
      { name: "Ethiopia", flag: "🇪🇹", slug: "ethiopia", dialCode: "251" },
      { name: "Nigeria", flag: "🇳🇬", slug: "nigeria", dialCode: "234" },
      { name: "Somalia", flag: "🇸🇴", slug: "somalia", dialCode: "252" },
      { name: "Kenya", flag: "🇰🇪", slug: "kenya", dialCode: "254" },
    ],
    seoTitle: "Affordable International Calls from Canada | elefa Connect",
    seoDescription: "Make affordable HD international calls from Canada to Ethiopia, Nigeria, Somalia, Kenya and every country worldwide. No contracts, credit never expires.",
  },
  "call-from-nz": {
    name: "New Zealand", slug: "call-from-nz", iso2: "NZ", flag: "🇳🇿",
    emergencyNumber: "111", currency: "NZD",
    regulatoryNotice: "elefa Connect cannot be used to call 111 emergency services. Always have access to a traditional phone for emergencies.",
    popularDestinations: [
      { name: "South Sudan", flag: "🇸🇸", slug: "south-sudan", dialCode: "211" },
      { name: "Ethiopia", flag: "🇪🇹", slug: "ethiopia", dialCode: "251" },
      { name: "Nigeria", flag: "🇳🇬", slug: "nigeria", dialCode: "234" },
      { name: "Kenya", flag: "🇰🇪", slug: "kenya", dialCode: "254" },
    ],
    seoTitle: "Affordable International Calls from New Zealand | elefa Connect",
    seoDescription: "Make affordable HD international calls from New Zealand to South Sudan, Ethiopia, Nigeria, Kenya and every country worldwide. Credit never expires.",
  },
  "call-from-australia": {
    name: "Australia", slug: "call-from-australia", iso2: "AU", flag: "🇦🇺",
    emergencyNumber: "000", currency: "AUD",
    regulatoryNotice: "elefa Connect cannot be used to call 000 or 112 emergency services. Always have access to a traditional phone for emergencies.",
    popularDestinations: [
      { name: "South Sudan", flag: "🇸🇸", slug: "south-sudan", dialCode: "211" },
      { name: "Ethiopia", flag: "🇪🇹", slug: "ethiopia", dialCode: "251" },
      { name: "Somalia", flag: "🇸🇴", slug: "somalia", dialCode: "252" },
      { name: "Nigeria", flag: "🇳🇬", slug: "nigeria", dialCode: "234" },
    ],
    seoTitle: "Affordable International Calls from Australia | elefa Connect",
    seoDescription: "Make affordable HD international calls from Australia to South Sudan, Ethiopia, Somalia, Nigeria and every country worldwide. Credit never expires.",
  },
  "call-from-germany": {
    name: "Germany", slug: "call-from-germany", iso2: "DE", flag: "🇩🇪",
    emergencyNumber: "112", currency: "EUR",
    regulatoryNotice: "elefa Connect is a VoIP service and cannot be used to call 112 emergency services. Always have access to a traditional phone for emergencies.",
    popularDestinations: [
      { name: "Eritrea", flag: "🇪🇷", slug: "eritrea", dialCode: "291" },
      { name: "Ethiopia", flag: "🇪🇹", slug: "ethiopia", dialCode: "251" },
      { name: "Nigeria", flag: "🇳🇬", slug: "nigeria", dialCode: "234" },
      { name: "Ghana", flag: "🇬🇭", slug: "ghana", dialCode: "233" },
    ],
    seoTitle: "Günstige Auslandsgespräche aus Deutschland | elefa Connect",
    seoDescription: "Günstig nach Eritrea, Äthiopien, Nigeria, Ghana und jedes Land weltweit telefonieren. HD-Sprachqualität, keine Verträge, Guthaben verfällt nie.",
  },
  "call-from-france": {
    name: "France", slug: "call-from-france", iso2: "FR", flag: "🇫🇷",
    emergencyNumber: "112", currency: "EUR",
    regulatoryNotice: "elefa Connect is a VoIP service and cannot be used to call emergency services (15, 17, 18, 112). Always have access to a traditional phone for emergencies.",
    popularDestinations: [
      { name: "Senegal", flag: "🇸🇳", slug: "senegal", dialCode: "221" },
      { name: "Mali", flag: "🇲🇱", slug: "mali", dialCode: "223" },
      { name: "Cameroon", flag: "🇨🇲", slug: "cameroon", dialCode: "237" },
      { name: "Morocco", flag: "🇲🇦", slug: "morocco", dialCode: "212" },
    ],
    seoTitle: "Appels internationaux pas chers depuis la France | elefa Connect",
    seoDescription: "Appelez le Sénégal, le Mali, le Cameroun, le Maroc et tous les pays du monde à petit prix. Qualité HD, sans engagement, crédit sans expiration.",
  },
  "call-from-sweden": {
    name: "Sweden", slug: "call-from-sweden", iso2: "SE", flag: "🇸🇪",
    emergencyNumber: "112", currency: "SEK",
    regulatoryNotice: "elefa Connect is a VoIP service and cannot be used to call 112 emergency services. Always have access to a traditional phone for emergencies.",
    popularDestinations: [
      { name: "Somalia", flag: "🇸🇴", slug: "somalia", dialCode: "252" },
      { name: "Eritrea", flag: "🇪🇷", slug: "eritrea", dialCode: "291" },
      { name: "Ethiopia", flag: "🇪🇹", slug: "ethiopia", dialCode: "251" },
      { name: "Iraq", flag: "🇮🇶", slug: "iraq", dialCode: "964" },
    ],
    seoTitle: "Billiga utlandssamtal från Sverige | elefa Connect",
    seoDescription: "Ring billigt till Somalia, Eritrea, Etiopien, Irak och varje land. HD-kvalitet, inga avtal, kredit som aldrig går ut.",
  },
  "call-from-netherlands": {
    name: "the Netherlands", slug: "call-from-netherlands", iso2: "NL", flag: "🇳🇱",
    emergencyNumber: "112", currency: "EUR",
    regulatoryNotice: "elefa Connect is a VoIP service and cannot be used to call 112 emergency services. Always have access to a traditional phone for emergencies.",
    popularDestinations: [
      { name: "Morocco", flag: "🇲🇦", slug: "morocco", dialCode: "212" },
      { name: "Ghana", flag: "🇬🇭", slug: "ghana", dialCode: "233" },
      { name: "Somalia", flag: "🇸🇴", slug: "somalia", dialCode: "252" },
      { name: "Suriname", flag: "🇸🇷", slug: "suriname", dialCode: "597" },
    ],
    seoTitle: "Goedkoop internationaal bellen vanuit Nederland | elefa Connect",
    seoDescription: "Bel goedkoop naar Marokko, Ghana, Somalië, Suriname en elk land. HD-kwaliteit, geen contracten, tegoed verloopt nooit.",
  },
  "call-from-italy": {
    name: "Italy", slug: "call-from-italy", iso2: "IT", flag: "🇮🇹",
    emergencyNumber: "112", currency: "EUR",
    regulatoryNotice: "elefa Connect is a VoIP service and cannot be used to call 112 or 113 emergency services. Always have access to a traditional phone for emergencies.",
    popularDestinations: [
      { name: "Nigeria", flag: "🇳🇬", slug: "nigeria", dialCode: "234" },
      { name: "Senegal", flag: "🇸🇳", slug: "senegal", dialCode: "221" },
      { name: "Morocco", flag: "🇲🇦", slug: "morocco", dialCode: "212" },
      { name: "Egypt", flag: "🇪🇬", slug: "egypt", dialCode: "20" },
    ],
    seoTitle: "Chiamate internazionali economiche dall'Italia | elefa Connect",
    seoDescription: "Chiama Nigeria, Senegal, Marocco, Egitto e ogni paese a basso costo. Qualità HD, nessun contratto, credito senza scadenza.",
  },
  "call-from-belgium": {
    name: "Belgium", slug: "call-from-belgium", iso2: "BE", flag: "🇧🇪",
    emergencyNumber: "112", currency: "EUR",
    regulatoryNotice: "elefa Connect is a VoIP service and cannot be used to call 112 emergency services. Always have access to a traditional phone for emergencies.",
    popularDestinations: [
      { name: "DR Congo", flag: "🇨🇩", slug: "dr-congo", dialCode: "243" },
      { name: "Morocco", flag: "🇲🇦", slug: "morocco", dialCode: "212" },
      { name: "Rwanda", flag: "🇷🇼", slug: "rwanda", dialCode: "250" },
      { name: "Burundi", flag: "🇧🇮", slug: "burundi", dialCode: "257" },
    ],
    seoTitle: "Appels internationaux pas chers depuis la Belgique | elefa Connect",
    seoDescription: "Appelez la RD Congo, le Maroc, le Rwanda, le Burundi et tous les pays du monde à petit prix. Qualité HD, sans engagement, crédit sans expiration.",
  },
  "call-from-ireland": {
    name: "Ireland", slug: "call-from-ireland", iso2: "IE", flag: "🇮🇪",
    emergencyNumber: "112/999", currency: "EUR",
    regulatoryNotice: "elefa Connect is a VoIP service and cannot be used to call 112 or 999 emergency services. Always have access to a traditional phone for emergencies.",
    popularDestinations: [
      { name: "Nigeria", flag: "🇳🇬", slug: "nigeria", dialCode: "234" },
      { name: "South Africa", flag: "🇿🇦", slug: "south-africa", dialCode: "27" },
      { name: "Zimbabwe", flag: "🇿🇼", slug: "zimbabwe", dialCode: "263" },
      { name: "Kenya", flag: "🇰🇪", slug: "kenya", dialCode: "254" },
    ],
    seoTitle: "Affordable International Calls from Ireland | elefa Connect",
    seoDescription: "Make affordable HD international calls from Ireland to Nigeria, South Africa, Zimbabwe, Kenya and every country worldwide. Credit never expires.",
  },
  "call-from-south-africa": {
    name: "South Africa", slug: "call-from-south-africa", iso2: "ZA", flag: "🇿🇦",
    emergencyNumber: "10111", currency: "ZAR",
    regulatoryNotice: "elefa Connect is a VoIP service and cannot be used to call 10111 emergency services. Always have access to a traditional phone for emergencies.",
    popularDestinations: [
      { name: "Zimbabwe", flag: "🇿🇼", slug: "zimbabwe", dialCode: "263" },
      { name: "Mozambique", flag: "🇲🇿", slug: "mozambique", dialCode: "258" },
      { name: "DR Congo", flag: "🇨🇩", slug: "dr-congo", dialCode: "243" },
      { name: "Nigeria", flag: "🇳🇬", slug: "nigeria", dialCode: "234" },
    ],
    seoTitle: "Affordable International Calls from South Africa | elefa Connect",
    seoDescription: "Make affordable HD international calls from South Africa to Zimbabwe, Mozambique, DR Congo, Nigeria and every country worldwide. Credit never expires.",
  },
  "call-from-uae": {
    name: "the UAE", slug: "call-from-uae", iso2: "AE", flag: "🇦🇪",
    emergencyNumber: "999", currency: "AED",
    regulatoryNotice: "elefa Connect cannot be used to call emergency services (999, 998, 997). Always have access to a traditional phone for emergencies.",
    popularDestinations: [
      { name: "Ethiopia", flag: "🇪🇹", slug: "ethiopia", dialCode: "251" },
      { name: "Kenya", flag: "🇰🇪", slug: "kenya", dialCode: "254" },
      { name: "Nigeria", flag: "🇳🇬", slug: "nigeria", dialCode: "234" },
      { name: "Sudan", flag: "🇸🇩", slug: "sudan", dialCode: "249" },
    ],
    seoTitle: "Affordable International Calls from UAE | elefa Connect",
    seoDescription: "Make affordable HD international calls from the UAE to Ethiopia, Kenya, Nigeria, Sudan and every country worldwide. Credit never expires.",
  },
  "call-from-saudi": {
    name: "Saudi Arabia", slug: "call-from-saudi", iso2: "SA", flag: "🇸🇦",
    emergencyNumber: "911", currency: "SAR",
    regulatoryNotice: "elefa Connect is a VoIP service and cannot be used to call 911 emergency services. Always have access to a traditional phone for emergencies.",
    popularDestinations: [
      { name: "Ethiopia", flag: "🇪🇹", slug: "ethiopia", dialCode: "251" },
      { name: "Sudan", flag: "🇸🇩", slug: "sudan", dialCode: "249" },
      { name: "Nigeria", flag: "🇳🇬", slug: "nigeria", dialCode: "234" },
      { name: "Egypt", flag: "🇪🇬", slug: "egypt", dialCode: "20" },
    ],
    seoTitle: "Affordable International Calls from Saudi Arabia | elefa Connect",
    seoDescription: "Make affordable HD international calls from Saudi Arabia to Ethiopia, Sudan, Nigeria, Egypt and every country worldwide. Credit never expires.",
  },
  "call-from-israel": {
    name: "Israel", slug: "call-from-israel", iso2: "IL", flag: "🇮🇱",
    emergencyNumber: "100", currency: "ILS",
    regulatoryNotice: "elefa Connect is a VoIP service and cannot be used to call 100, 101, or 102 emergency services. Always have access to a traditional phone for emergencies.",
    popularDestinations: [
      { name: "Ethiopia", flag: "🇪🇹", slug: "ethiopia", dialCode: "251" },
      { name: "Eritrea", flag: "🇪🇷", slug: "eritrea", dialCode: "291" },
      { name: "Sudan", flag: "🇸🇩", slug: "sudan", dialCode: "249" },
      { name: "South Sudan", flag: "🇸🇸", slug: "south-sudan", dialCode: "211" },
    ],
    seoTitle: "Affordable International Calls from Israel | elefa Connect",
    seoDescription: "Make affordable HD international calls from Israel to Ethiopia, Eritrea, Sudan, South Sudan and every country worldwide. Credit never expires.",
  },
};
